/**
 * Configurazione skin per white-label.
 *
 * Ogni chiave è un hostname (window.location.hostname).
 * Per aggiungere una nuova skin basta aggiungere un oggetto qui.
 */

export const DEFAULT_SKIN_ID = "poderi.app"; // ID della skin di default (fallback)


      //  All'interno del porgetto  "Oliveto e Vigneto Digitale" della Fondazione ITS - EAT,
      //  questa piattaforma è stata sviluppata come strumento didattico per la gestione digitale dell'oliveto sperimentale dell'EAT di Grosseto.
      //  Gli studenti possono utilizzare l'app per monitorare le piante, pianificare le attività colturali e analizzare i dati raccolti, acquisendo competenze pratiche nella gestione agricola moderna.


export const skins = {
  "mai.poderi.app": {
    id: "mai",
    appName: null,
    sidebarTitle: null,
    logo: "/icons/fairshare.png",
    description:
      "Piattaforma completa per la gestione della tua azienda agricola. Monitora appezzamenti, pianifica stagioni, gestisci le rotazioni colturali e molto altro.",
    features: [
      {
        icon: "map",
        title: "Mappe Interattive",
        text: "Visualizza e gestisci i tuoi appezzamenti su mappa",
      },
      {
        icon: "calendar",
        title: "Pianificazione",
        text: "Organizza le stagioni e le attività con Gantt",
      },
      {
        icon: "refresh-cw",
        title: "Rotazioniaaa",
        text: "Gestisci le rotazioni colturali in modo efficiente",
      },
      {
        icon: "bar-chart-3",
        title: "Analisi",
        text: "Monitora le performance delle tue coltivazioni",
      },
    ],
    colors: {
      "--skin-primary": "#4299e1",
      "--skin-primary-hover": "#3182ce",
      "--skin-primary-light": "rgba(66, 153, 225, 0.15)",
      "--skin-accent": "#48bb78",
      "--skin-accent-hover": "#38a169",
    },
    footer: "&copy; 2025 Aedit s.r.l.",
  },
  "edu.poderi.app": {
    id: "edu",
    appName: "Poderi - Oliveto Digitale",
    sidebarTitle: null, 
    logo:  "/icons/fairshare.png",  
    credits: [
      {
        headerClass: null,
        logo: "/icons/loghi_edu.png",
        title: "NextGenerationEU",
        text: `Finanziata nell'ambito del Piano Nazionale di Ripresa e Resilienza (PNRR), Missione 4 – Istruzione e Ricerca, Componente 1, Investimento 1.5 "Sviluppo del sistema di formazione professionale terziaria (ITS)" – finanziato dall'Unione Europea – NextGenerationEU. CUP C54D23003440006`,
        link: null,
      },
      //https://fondazione-eat.it/
      {
        headerClass: null,
        logo: "/icons/fondazione-eat.png",
        title: "Fondazione EAT",
        text: `La <a class="credit-link" href="https://fondazione-eat.it/" target="_blank" rel="noopener">Fondazione EAT</a> investe nel settore AGROALIMENTARE sul territorio toscano per la formazione di tecnici altamente qualificati allo scopo di migliorare la competitività del sistema economico-produttivo regionale.`,
        link: null,
      },
      {
        headerClass: null,
        logo: "/icons/fairshare.png",
        title: "AEDIT srl",
        text: `La piattaforma è stata sviluppata da <a class="credit-link" href="http://www.aedit.it/" target="_blank" rel="noopener">AEDIT srl</a>.`,
        link: null,
      },
    ],
    description: `
      <p>
        Poderi Edu è la piattaforma didattica sviluppata nell'ambito del progetto PNRR "Vigneto e Oliveto Digitale" della Fondazione ITS EAT, per la gestione digitale dell'oliveto dell'Istituto Agrario di Firenze.
      </p>
      <p>
        Gli studenti possono monitorare le piante, pianificare le attività colturali e analizzare i dati raccolti sul campo, avvicinandosi all'olivicoltura del futuro attraverso dati e tecnologia.
      </p>
    `,
    features: [
      // {
      //   icon: "map",
      //   title: "Mappe Interattive",
      //   text: "Visualizza e gestisci i tuoi appezzamenti su mappa",
      // },
      // {
      //   icon: "calendar",
      //   title: "Pianificazione",
      //   text: "Organizza le stagioni e le attività con Gantt",
      // },
      // {
      //   icon: "refresh-cw",
      //   title: "Rotazioni",
      //   text: "Gestisci le rotazioni colturali in modo efficiente",
      // },
      // {
      //   icon: "bar-chart-3",
      //   title: "Analisi",
      //   text: "Monitora le performance delle tue coltivazioni",
      // },
    ],
    colors: {
      "--skin-primary": "#4299e1",
      "--skin-primary-hover": "#3182ce",
      "--skin-primary-light": "rgba(66, 153, 225, 0.15)",
      "--skin-accent": "#48bb78",
      "--skin-accent-hover": "#38a169",
    },
    footer: "&copy; 2025 Aedit s.r.l.",
  },
  "virtualfarm.poderi.app": {
    id: "virtualfarm",
    appName: "VirtualFarm - Santa Paolina",
    sidebarTitle: "VirtualFarm ",
    logo:  "/icons/fairshare.png",
    description: `
        VirtualFarm è una piattaforma digitale sviluppata per supportare la gestione
        dell'Azienda sperimentale “<a href="#/azienda/santa-paolina">Santa Paolina</a>” di Follonica dell'Istituto per la BioEconomia (IBE) del CNR.
        Progettata per facilitare il monitoraggio e la gestione delle coltivazioni, con 
        funzionalità specifiche per la gestione delle collezioni varietali dell'azienda. 
    `,
    features: [
      // {
      //   icon: "map",
      //   title: "Campo Virtuale",
      //   text: "Mappa interattiva delle piante nel campo sperimentale",
      // },
      // {
      //   icon: "database",
      //   title: "Accessioni",
      //   text: "Gestisci accessioni e varietà con importazione Excel",
      // },
      // {
      //   icon: "bar-chart-3",
      //   title: "Monitoraggio",
      //   text: "Registra osservazioni e operazioni sulle piante",
      // },
      // {
      //   icon: "refresh-cw",
      //   title: "Rotazioni",
      //   text: "Pianifica le rotazioni colturali",
      // },
    ],
    colors: {
      "--skin-primary": "#6b8e23",
      "--skin-primary-hover": "#556b2f",
      "--skin-primary-light": "rgba(107, 142, 35, 0.15)",
      "--skin-accent": "#daa520",
      "--skin-accent-hover": "#b8860b",
    },
    footer: "&copy; 2025 Aedit s.r.l.",
  },
  "poderi.app": {
    id: "poderi.app",
    appName: null,
    sidebarTitle: null,
    logo: "/icons/fairshare.png",
    description: `
        Benvenuto in poderi 2.0. Il sistema informativo permette la gestione completa dei dati aziendali, sia per le produzioni vegetali che per gli allevamenti.
        Il sistema è in corso di sviluppo per ogni segnalazione scrivete a <a href="mailto:assistenza@aedit.it">assistenza@aedit.it</a>.
    `,
    features: [],
    colors: {
      "--skin-primary": "#9fbc4a",
      "--skin-primary-hover": "#556b2f",
      "--skin-primary-light": "rgba(107, 142, 35, 0.15)",
      "--skin-accent": "#daa520",
      "--skin-accent-hover": "#b8860b",
    },
    footer: "&copy; 2025 Aedit s.r.l.",
  },
};

/**
 * Ritorna la skin per un dato hostname.
 * Fallback: prima skin disponibile (DEFAULT_SKIN_ID).
 */
export function getSkinByHostname(hostname) {
  if (skins[hostname]) {
    return skins[hostname]
  }



  // Fallback: cerca per id default
  const fallback = Object.values(skins).find(s => s.id === DEFAULT_SKIN_ID)
  return fallback || Object.values(skins)[0]
}
